export default __webpack_public_path__ + "static/media/pancake.2fa63a83.svg";